import React, { createContext } from 'react';
import useNavbar, { UseNavbar } from '../hooks/useNavbar';

const NavbarContext = createContext<UseNavbar>({} as UseNavbar);

const NavbarProvider: React.FC = ({ children }) => {
  const { openMenu, setOpenMenu, closeMenuOnScroll, setCloseMenuOnScroll } =
    useNavbar();

  return (
    <NavbarContext.Provider
      value={{
        openMenu,
        setOpenMenu,
        closeMenuOnScroll,
        setCloseMenuOnScroll,
      }}
    >
      {children}
    </NavbarContext.Provider>
  );
};

export { NavbarContext, NavbarProvider };
